import React, { useEffect, useState } from 'react';
import App from './App';
import SignIn from './components/SignIn';
import { api } from './services/api';
import StoreApp from './store/StoreApp';
import { SessionProvider } from './session';
import { SignedInUser } from './types';

/**
 * Šta se vidi zavisi od toga ko je prijavljen.
 *
 * Operater dobija svoj ekran, poslovođa svoj objekat — i to onaj koji stoji uz
 * njegov nalog, ne onaj koji je neko upisao u adresu. Ranije je `?mpo=001`
 * otvarao bilo čiju prodaju svakome ko zna šifru.
 *
 * Vozač ovde ne prolazi: njegov ekran radi bez mreže i bez prijavljivanja.
 */
export default function SignedInApp() {
  const [user, setUser] = useState<SignedInUser | null>(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    api.me()
      .then(setUser)
      .catch(() => setUser(null))
      .finally(() => setChecked(true));
  }, []);

  // Dok se ne zna ko je, ne prikazuje se ništa: pola ekrana pa prijava izgleda
  // kao da je nešto puklo.
  if (!checked) {
    return <div className="signin"><p className="muted">Učitavam…</p></div>;
  }

  if (!user) {
    return <SignIn onSignedIn={setUser} />;
  }

  const signOut = () => {
    api.logout().catch(() => undefined).finally(() => setUser(null));
  };

  return (
    <SessionProvider user={user}>
      {user.role === 'StoreManager' && user.storeCode
        ? <StoreApp code={user.storeCode} onSignOut={signOut} />
        : <App onSignOut={signOut} />}
    </SessionProvider>
  );
}
